export default __webpack_public_path__ + "static/media/defaultplaceholder_light.2c9434c9.svg";